/**
 * Event signup_step_transition.js dispatches on #profile-step once it enables
 * the step, so the gate re-checks fields that were exempt from validation
 * while the fieldset was disabled.
 */
export const PROFILE_STEP_REVEALED_EVENT = 'signup:profile-step-revealed';

/**
 * Disables the sign-up submit button until every required profile field is
 * valid: names, work/job title, country, both consents, and the phone when an
 * invite makes it required. It reads the browser's own constraint validation
 * (`required`, `pattern`, custom validity set by the picker and the phone
 * dial-code), so a field marked required in the view is gated with no change
 * here. The fields are checked one by one: a fieldset is itself barred from
 * constraint validation, so its own checkValidity() is always true. While the
 * password step shows, the disabled fieldset exempts its fields as well, hence
 * the explicit `profileStep.disabled` check.
 */
export const initRequiredFieldsGate = () => {
  const button = document.getElementById('create-account-button');
  const profileStep = document.getElementById('profile-step');
  if (!button || !profileStep) return;

  const allFieldsValid = () => [...profileStep.elements]
    .every((field) => !field.willValidate || field.checkValidity());

  const syncDisabledState = () => {
    button.disabled = profileStep.disabled || !allFieldsValid();
  };

  profileStep.addEventListener('input', syncDisabledState);
  profileStep.addEventListener('change', syncDisabledState);
  profileStep.addEventListener(PROFILE_STEP_REVEALED_EVENT, syncDisabledState);
  syncDisabledState();
};
